import { GridColumn } from '@tkww/orion-web-ds-structure';
import { BOW } from '@utils/tracking';
import React, { type FunctionComponent } from 'react';
import TrackableCard from '../../../../../components/trackable_card';
import Styles from '../styles.scss';

interface Props {
	category: Category.Category;
	vendor: Vendor.Raw;
	index: number;
	isFeatured: boolean;
}

const BOWCard: FunctionComponent<Props> = ({
	category,
	vendor,
	index,
	isFeatured,
}) => {
	return (
		<GridColumn lg="4" className={Styles.cardContainer}>
			<TrackableCard
				impressionDetails={{
					impressionType: 'Landings: Best of Weddings',
					locationIndex: index,
					vendor,
				}}
				vendor={vendor}
				type="lg"
				cardProps={{
					isFeatured,
				}}
				trackingData={{
					properties: {
						sourcePage: BOW,
						vendorCategory: category.name,
						impressionPosition: index,
					},
				}}
				vendorCardClasses={{ 'vendor-name': Styles.vendorName }}
				newTagEnabled={false}
				aiPhotoEnabled={false}
				renderOdsCard={false}
			/>
		</GridColumn>
	);
};

export default BOWCard;
